import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import {
  TSFNNewRequestControlName,
  TSFNNewRequestFormGroup,
} from './new-request-form.model';

@Injectable()
export class TSFNNewRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
  ) {}

  getFormGroup(): FormGroup<TSFNNewRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonInvestorFormGroup(
        {
          [ECSControlName.ElectronicCorrespondenceStatement]: false,
        },
        {
          addressFormGroupBasedOnSelectControls: true,
          disableAddressFormInNaturalPersonGroup: true,
        },
      ).controls,
      [TSFNNewRequestControlName.TreesNumber]: this.formBuilder.control(
        getDefaultControlValue(),
        [Validators.required],
      ),
      [TSFNNewRequestControlName.TreesDescription]: this.formBuilder.control(
        getDefaultControlValue(),
        [Validators.required],
      ),
    });
  }
}
